type BillingLocale = typeof import('../en/billing').default

const billing = {
	pricing: {
		title: 'Planes de Suscripción',
		subtitle: 'Elige el plan que mejor se adapte a ti',
		noPlans: 'No hay planes disponibles',
		noPlansDescription:
			'Los planes de suscripción no están disponibles en este momento. Vuelve a intentarlo más tarde.',
		signInToSubscribe: 'Inicia sesión para suscribirte',
		subscribe: 'Suscribirse',
		allFeatures: 'Todas las funciones incluidas',
		disabledTitle: 'Facturación no disponible',
		disabledDescription:
			'Las suscripciones están deshabilitadas. Vuelve a intentarlo más tarde.',
	},
	upgradeMoment: {
		facet: {
			title: 'Crea tus propias facetas de este tema',
			body: 'Las facetas dan otro ángulo a cada tema: un desarrollo en profundidad, un glosario, tarjetas para fijar lo aprendido. Con Pro las creas en cualquier ruta y haces tuyo lo que aprendes.',
			titleWithContext: 'Crea tus propias facetas de «{{name}}»',
			bodyWithContext:
				'Las facetas dan otro ángulo a «{{name}}»: un desarrollo en profundidad, un glosario, tarjetas para fijar lo aprendido. Con Pro las creas en cualquier ruta y haces tuyo lo que aprendes.',
		},
		resources: {
			title: 'Reúne los recursos de este tema',
			body: 'Pro recopila vídeos, artículos y referencias para ampliar cada tema, en cualquiera de tus rutas. Así el tema deja de ser un punto de partida y se convierte en tu material de trabajo.',
			titleWithContext: 'Reúne los recursos de «{{name}}»',
			bodyWithContext:
				'Pro recopila vídeos, artículos y referencias para ampliar «{{name}}» y cualquier otro tema de tus rutas. Así el tema deja de ser un punto de partida y se convierte en tu material de trabajo.',
		},
		generic: {
			title: 'Lleva este tema más lejos',
			body: 'Pro te da las herramientas para convertir cada tema en criterio que aplicas: nuevas facetas y recursos seleccionados, en cualquier ruta.',
		},
		budget: {
			title: 'Tus rutas gratis están en uso',
			body: 'Todo lo que has empezado sigue disponible. Con Pro abres cualquier ruta o programa del catálogo y sigues construyendo criterio sin pausas.',
			titleWithContext: 'Sigue con «{{name}}» en Pro',
			bodyWithContext:
				'Tus rutas gratis están en uso y todo lo que has empezado sigue disponible. Con Pro abres «{{name}}» y cualquier otra ruta o programa del catálogo.',
		},
		primaryCta: 'Pasar a Pro',
		secondaryCta: 'Ahora no',
	},
	degustacion: {
		includedFree: 'Incluido gratis',
	},
	success: {
		title: 'Pago exitoso',
		description:
			'Gracias por suscribirte. Tu pago se ha procesado correctamente.',
		processingDescription:
			'Tu pago está confirmado y estamos activando tu suscripción.',
		processingNote:
			'Esto suele tardar unos segundos. Actualiza la página si tu suscripción no aparece pronto.',
		whatNext: '¿Qué sigue?',
		accessGranted: 'Tu suscripción ya está activa',
		emailConfirmation: 'Recibirás un correo de confirmación en breve',
		fullAccess:
			'Ahora tienes acceso completo a todas las funciones de suscripción',
		goToDashboard: 'Ir al panel',
		manageSubscription: 'Administrar suscripción',
	},
	cancel: {
		title: 'Pago cancelado',
		description: 'Tu pago fue cancelado. No se realizaron cargos a tu cuenta.',
		needHelp: '¿Necesitas ayuda?',
		contactSupport:
			'Si tuviste un problema durante el pago o tienes preguntas sobre los planes, contacta a soporte.',
		tryAgain: 'Intentar de nuevo',
		backToDashboard: 'Volver al panel',
	},
	settings: {
		title: 'Facturación',
		description: 'Administra tu suscripción y métodos de pago',
		subscriptionStatus: 'Estado de suscripción',
		subscriptionDescription: 'Ver y administrar los detalles de tu suscripción',
		noSubscription: 'No tienes una suscripción activa',
		viewPlans: 'Ver planes',
		plan: 'Plan',
		amount: 'Importe',
		endsOn: 'La suscripción termina el',
		renewsOn: 'Se renueva el',
		gracePeriod: 'Tu suscripción fue cancelada y terminará el {date}',
		manageSubscription: 'Administrar suscripción',
		portalDescription:
			'Actualiza métodos de pago, ve facturas y administra tu suscripción',
		customerPortal: 'Portal de clientes',
		openPortal: 'Abrir portal en una nueva pestaña',
		portalMissingToken:
			'El portal de facturación todavía no está configurado. Contacta con soporte o inténtalo más tarde.',
		portalError:
			'No pudimos cargar el portal de facturación. Inténtalo más tarde.',
		portalUnavailable:
			'El portal de facturación no está disponible en este momento.',
		statuses: {
			active: 'Activa',
			trialing: 'Prueba',
			past_due: 'Pago pendiente',
			canceled: 'Cancelada',
			incomplete: 'Incompleta',
		},
	},
	banner: {
		subscriptionCanceled: 'Suscripción cancelada',
		accessEndsOn:
			'Tu acceso terminará el {date} ({days} {days, plural, one {day} other {days}} restantes).',
		reactivate: 'Reactivar suscripción',
		manageSubscription: 'Administrar suscripción',
		paymentPastDue: 'Pago vencido',
		paymentPastDueDescription:
			'Tu pago está vencido. Actualiza tu método de pago para evitar interrupciones.',
		updatePayment: 'Actualizar método de pago',
		trialEnding: 'Prueba por finalizar',
		trialEndingDescription:
			'Tu prueba termina el {date} ({days} {days, plural, one {day} other {days}} restantes).',
		viewBilling: 'Ver detalles de facturación',
	},
	accessGate: {
		subscriptionRequired: 'Suscripción requerida',
		subscriptionRequiredDescription:
			'Este curso requiere una suscripción activa para acceder.',
		whySubscription: '¿Por qué suscribirse?',
		benefit1: 'Acceso ilimitado a todos los cursos de suscripción',
		benefit2: 'Nuevos cursos agregados regularmente',
		benefit3: 'Cancela cuando quieras',
		viewPlans: 'Ver planes',
		upgradeNow: 'Mejorar a Pro',
		backToDashboard: 'Volver al panel',
		enrollmentRequired: 'Inscripción requerida',
		enrollmentRequiredDescription:
			'Necesitas inscribirte en "{courseName}" para acceder a este curso.',
		enrollmentNote:
			'Tienes una suscripción activa, pero necesitas inscribirte en este curso para acceder.',
		enrollNow: 'Inscribirse ahora',
		signInRequired: 'Inicio de sesión requerido',
		signInRequiredDescription: 'Inicia sesión para acceder a este curso.',
		signIn: 'Iniciar sesión',
		createAccount: 'Crear cuenta',
		accessDenied: 'Acceso denegado',
		accessDeniedDescription: 'No tienes permiso para acceder a este curso.',
	},
} satisfies BillingLocale

export default billing
